export const getInitState = () => {
  return {
    data: [],
    defActionName: '',
    playTime: -1, // 播放次数，当传 -1 代表无限循环，默认循环
    autoDestory: false,
    interval: 100,
    pingpong: false,
    defPlay: true,
    autoPlay: true, // 入场自动播放
    keepLastFrame: false, // 保持尾帧
  }
}
